<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :label="label"
        v-model="data_formatada"
        ref="text_field"
        append-icon="event"
        :rules="rulesForm.campo"
        @click:append="setHoje"
        :readonly="readonly"
        v-bind="attrs"
        v-on="on"
        :hide-details="hideDetails"
        :disabled="disabled"
        :filled="filled"
        :placeholder="placeholder"
        :persistent-placeholder="persistentPlaceholder"
        :background-color="backgroundColor"
        autocomplete="off"
        role="presentation"
        v-mask="'##/##/####'"
        :return-masked-value="true"
        @change="onChange"
        @input="onInputChange"
        @keydown.native.enter="$emit('enter')"
      ></v-text-field>
    </template>

    <v-date-picker
      v-model="date"
      :readonly="readonly"
      :min="min"
      :max="max"
      @input="menu = false"
      @change="onDateChange"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import dateMixin from "@/mixins/date-mixin";

export default {
  name: "as-date-picker-menu",
  mixins: [dateMixin],
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: "",
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    min: {
      type: String,
      default: null,
    },
    max: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    persistentPlaceholder: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      data_formatada: this.dataBR(this.value),
      date: this.value,
      menu: false,
      rulesForm: {
        campo: [(value) => !!value || "Campo Obrigatório"],
      },
    };
  },

  methods: {
    onDateChange(value) {
      this.menu = false;
      this.data_formatada = this.dataBR(value);
      this.$emit("input", value);
    },

    onChange(value) {
      this.menu = false;
      if(value) {
        const temp = value.split("/");
        try {
          const data = new Date(temp[2] + "-" + temp[1] + "-" + temp[0]);
          if (data > new Date("2003-01-01")) {
            this.date = temp[2] + "-" + temp[1] + "-" + temp[0];
          } else {
            this.date = null;
            this.data_formatada = "";
          }
        } catch (error) {
          this.date = null;
          this.data_formatada = "";
        }
        this.$emit("input", this.date);
      }
    },
    
    onInputChange(value) {
      this.menu = false;
      if (value) {
        const temp = value.split("/");
        try {
          const data = new Date(temp[2] + "-" + temp[1] + "-" + temp[0]);
          if (data > new Date("2003-01-01")) {
            this.date = temp[2] + "-" + temp[1] + "-" + temp[0];
            this.$emit("input", this.date);
          }
        } catch (error) {
          // Notthing
        }
      }
    },

    setHoje() {
      if (this.disabled || this.readonly) return;
      const data = new Date();
      this.date =
        data.getFullYear() +
        "-" +
        (data.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        data
          .getDate()
          .toString()
          .padStart(2, "0");
      this.data_formatada = this.dataBR(this.date);
      this.$emit("input", this.date);
    },

    focus() {
      this.$refs.text_field.focus();
    }
  },

  watch: {
    value: function(newVal, oldVal) {
      this.data_formatada = this.dataBR(newVal);
      this.date = newVal;
    },
  },
};
</script>

<style scoped></style>
